exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,500,900&display=swap);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);", ""]);

// module
exports.push([module.id, "body {\n  font-family: \"Raleway\", sans-serif;\n}\n\nbody::-webkit-scrollbar {\n  display: none;\n}\n\nh1, h2, h3, h4, p {\n  margin: 0;\n}", ""]);

// exports
